import type { DefaultOptions } from '@apollo/client';

/**
 * The production Apollo client's request settings, kept free of side effects (no Firebase,
 * no links) so unit tests can build a client that behaves like the real one.
 * Used by `createApolloClient` in ./apollo.ts.
 */
export const APOLLO_DEFAULT_OPTIONS: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  },
  query: {
    pollInterval: 0,
    fetchPolicy: 'no-cache',
  },
  mutate: {
    fetchPolicy: 'no-cache',
  },
};

export const APOLLO_QUERY_DEDUPLICATION = false;
